export default "__VITE_ASSET__BqzA7SGd__"